import fileDownload from 'js-file-download';
import { put, select } from 'redux-saga/effects';
import { APIgetEmployeeListByFirm, APIgetNN05EmployeeId, APIgetNN05EmployeeIdValidate, APIgetNN05ExcelData, APIdeleteEmployee, APIpostNN05EmployeeInsert, APIpostNN05EmployeeUpdate, APIgetNN05LocationByPostalCode } from '../../felles/APICalls_NN05';
import PageImpl from '../../models/PageImpl';
import * as actions from '../actions';
import * as actionsNN05 from '../actions/indexNN05';
import * as selectors from '../selectors';

//
export function* getNN05EmployeeListSaga(payload) {
  try {
    yield put(actions.setIsloading(true));
    const { listFormData } = payload;
    let response;
    if (listFormData.exportToExcel) {
      response = yield APIgetNN05ExcelData(listFormData);
    } else {
      response = yield APIgetEmployeeListByFirm(listFormData);
    }
    if (response?.data) {
      if (listFormData.exportToExcel) {
        yield fileDownload(response.data, `Ansattliste.xlsx`);
      } else {
        yield put(actionsNN05.NN05PERSONListeGetSuccess(response.data as PageImpl<any>));
      }
    }
  } catch (error) {
    yield put(actionsNN05.NN05PERSONListeGetFailed(error));
  } finally {
    yield put(actions.setIsloading(false));
  }
}

export function* setTransInsertEmployeeSaga(payload) {
  try {
    yield put(actions.setIsloading(true));
    const { data, listFormData } = payload;

    const response = yield APIpostNN05EmployeeInsert(data);
    if (response?.data) {
      yield put(actionsNN05.setTransDialogEmployeeFeedback(response.data)); // 1 = Insert success
      if (listFormData) {
        yield put(actionsNN05.NN05PERSONListeGet(listFormData));
      }
    }
  } catch (error) {
    yield put(actionsNN05.setTransDialogEmployeeFeedback(error)); // 1 = Insert success
  } finally {
    yield put(actions.setIsloading(false));
    yield put(actionsNN05.setTransStateInsertEmployee(0));
    yield put(actionsNN05.setTransStateDialogEmployee(1));
  }
}


export function* setTransUpdateEmployeeSaga(payload) {
  try {
    yield put(actions.setIsloading(true));
    const { data, listFormData } = payload;
    const response = yield APIpostNN05EmployeeUpdate(data);
    if (response?.data) {
      yield put(actionsNN05.setTransDialogEmployeeFeedback(response.data)); // 1 = Insert success
      if (listFormData) {
        yield put(actionsNN05.NN05PERSONListeGet(listFormData));
      }
    }
  } catch (error) {
    yield put(actionsNN05.setTransDialogEmployeeFeedback(error)); // 1 = Insert success
  } finally {
    yield put(actions.setIsloading(false));
    yield put(actionsNN05.setTransStateUpdateEmployee(0));
    yield put(actionsNN05.setTransStateDialogEmployee(1));
  }
}

export function* setTransDeleteEmployeeSaga(payload) {
  try {
    yield put(actions.setIsloading(true));
    //const { formData, refreshParams } = payload;
    const pageData = yield select(selectors.NN05page);
    const { data, listFormData } = payload;
    const response = yield APIdeleteEmployee(data.employeeId);
    if (response?.data) {
      yield put(actionsNN05.setTransDialogEmployeeFeedback(response.data)); // 1 = Insert success
      if (listFormData) {
        yield put(actionsNN05.NN05PERSONListeGet(listFormData));
        yield put(actionsNN05.setCurrentRowFocused('001'));
        const index = pageData.content.findIndex(item => item.ansattnr === payload.data.ansattNr);
        if (pageData.content[index + 1] !== undefined) {
          yield put(actionsNN05.setCurrentRowFocused(pageData.content[index + 1].ansattnr));
        }
      }
    }
  } catch (error) {
    yield put(actionsNN05.setTransDialogEmployeeFeedback(error)); // 1 = Insert success
  } finally {
    yield put(actions.setIsloading(false));
    yield put(actionsNN05.setTransStateDeleteEmployee(0));
    yield put(actionsNN05.setTransStateDialogEmployee(1));
  }
}

export function* getNN05EmployeeIdSaga() {
  try {
    yield put(actions.setIsloading(true));
    const response = yield APIgetNN05EmployeeId();
    if (response?.data) {
      yield put(actionsNN05.getEmployeeIdSuccess(response.data.employeeId));
    }
  } catch (error) {
    yield put(actionsNN05.getEmployeeIdFailed(error));
  } finally {
    yield put(actions.setIsloading(false));
  }
}


export function* getNN05EmployeeIdValidateSaga(action) {
  try {
    yield put(actions.setIsloading(true));
    const response = yield APIgetNN05EmployeeIdValidate(action.payload);
    if (response?.data) {
      yield put(actionsNN05.getEmployeeIdValidateSuccess(response.data));
    }
  } catch (error) {
    yield put(actionsNN05.getEmployeeIdValidateFailed(error));
  } finally {
    yield put(actions.setIsloading(false));
  }
}


export function* getNN05LocationByPostalCodeSaga(action) {
  try {
    yield put(actions.setIsloading(true));
    const response = yield APIgetNN05LocationByPostalCode(action.payload);
    if (response?.data) {
      yield put(actionsNN05.getLocationByPostalCodeSuccess(response.data));
    }
  } catch (error) {
    yield put(actionsNN05.getLocationByPostalCodeFailed(error));
  } finally {
    yield put(actions.setIsloading(false));
  }
}

